module.exports = __webpack_public_path__ + "img/collage_home.82e770d9.png";